import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useDatatable } from '../../hooks/useDatatable.js';

import {
    project_report_applicant_list_json_path,
    project_report_edit_report_path
} from '~/routes';

function ApplicantReportListWidget({widgetId, widgetRef, theme}) {
    const tablePlaceholder = useRef();
    const tableRef = useRef();
    const tableContentRef = useRef();
    const initializedRef = useRef(false);
    const sorting = useSelector(state => state.dashboard.widgets[widgetId].settings.sorting);
    const filters = useSelector(state => state.dashboard.widgets[widgetId].settings.filters || []);
    const {pageCount, saveState} = useDatatable({widgetId, tablePlaceholder, tableRef, widgetRef, theme});

    const fixDate = (data) => {
        return data.status_updated_at;
    };

    const fixStatus = (data) => {
        if(data == 'pending_review'){
            return '<span class="' + data +'" style="background-color:grey;color:white;padding:5px;"> ' + I18n.t('reviewing') + ' </span>';
        } else if(data == 'pending_fill'){
            return '<span class="' + data +'" style="background-color:grey;color:white;padding:5px;"> ' + I18n.t('filling') + ' </span>';
        } else if(data == 'pending_approval'){
            return '<span class="' + data +'" style="background-color:grey;color:white;padding:5px;"> ' + I18n.t('approving') + ' </span>';
        }
    };

    const fixTitle = (data, type, row, meta) => {
        return '<a target="_blank" title="'+ data.name + '" data-title="'+ data.name + '" href="' + project_report_edit_report_path({project_id: data.project_id, report_id: data.monitoring_report_id, project_report_id: data.project_report_id}) + '">' + data.name + '</a>';
    };

    const fixRequest = (data) => {
        let tmp = [];
        if (filters) {
            filters.forEach((element) => {
                tmp.push(element.filter);
            });
        }
        data.filters = tmp;
        return data;
    };

    const initTable = () => {
        let table;

        const tableEl = tablePlaceholder.current;
        if ($.fn.DataTable.isDataTable(tableEl)) {
            tableEl.DataTable().destroy();
        }

        table = $(tableContentRef.current).DataTable({
            ordering: true,
            serverSide: true,
            ajax: {
                url: project_report_applicant_list_json_path(),
                data: fixRequest,
            },
            stateSave: true,
            stateSaveParams: saveState,
            info: true,
            searching: false,
            lengthChange: false,
            autoWidth: false,
            pageLength: pageCount,
            pagingType: "simple",
            language: {
                infoFiltered: "", //Hide the fact that the table is filtered
            },
            processing: false,
            sorting: sorting ? sorting[0] : [[2, "desc"]],
            columnDefs: [
                {
                    targets: 0,
                    className: "text-truncate",
                    width: "99%",
                },
                {
                    render: fixDate,
                    targets: 2,
                },
                {
                    render: fixTitle,
                    targets: 0,
                },
                {
                    render: fixStatus,
                    targets: 1,
                },
            ],
        });

        tableRef.current = table;
    };
    
    useEffect(() => {
        if (!tablePlaceholder.current || initializedRef.current) return;
        initTable();
        initializedRef.current = true;
    }, [tablePlaceholder.current, filters]);


    return (
        <div ref={tablePlaceholder} className="table-content data-table-widget" style={{ width: '100%'}}>
            <table ref={tableContentRef} id={`tasks-${widgetId}`} className="table table-striped table-hover tasks dataTable no-footer task-table nowrap tasks-widget" role="grid" aria-describedby={`tasks-${widgetId}_info`}>
                <thead>
                    <tr role="row">
                    <th data-col="title" style={{ paddingRight: 18 }} tabIndex={0} aria-controls={`tasks-${widgetId}`} aria-label={`${I18n.t('title')}: ${I18n.t('activate_to_sort_column_ascending')}`}>
                        {I18n.t('title')}
                    </th>
                    <th data-col="status" style={{ paddingRight: 18 }} tabIndex={0} aria-controls={`tasks-${widgetId}`} aria-label={`${I18n.t('status')}: ${I18n.t('activate_to_sort_column_ascending')}`}>
                        {I18n.t('status')}
                    </th>
                    <th data-col="created_at" style={{ paddingRight: 18 }} tabIndex={0} aria-controls={`tasks-${widgetId}`} aria-label={`${I18n.t('created_at')}: ${I18n.t('activate_to_sort_column_ascending')}`}>
                        {I18n.t('updated')}
                    </th>
                    </tr>
                </thead>
                <tbody className="table-body"></tbody>
            </table>
        </div>
    )
};

export default ApplicantReportListWidget;